import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IDashboardService } from "services/DashboardService";
import { CalendarEventModel } from "services/api/cplapi/CPLAPI";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";

const initialState = {
  WeeklyMeetings: new Array<CalendarEventModel>(),
  LoadingWeeklyMeetings: false,
};

export const WeeklyMeetingsSlice = createSlice({
  name: "weeklyMeetings",
  initialState,
  reducers: {
    setWeeklyMeetings: (state, action) => {
      state.WeeklyMeetings = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getWeeklyMeetings.pending, (state) => {
        state.LoadingWeeklyMeetings = true;
      })
      .addCase(getWeeklyMeetings.fulfilled, (state, action) => {
        state.WeeklyMeetings = action.payload;
        state.LoadingWeeklyMeetings = false;
      })
      .addCase(getWeeklyMeetings.rejected, (state) => {
        state.LoadingWeeklyMeetings = false;
      });
  },
});

export const getWeeklyMeetings = createAsyncThunk("weeklyMeetings/GetWeeklyMeetings", async () => {
  const dashboardService = container.get<IDashboardService>(SERVICE_TYPES.DashboardService);
  return await dashboardService.getWeeklyMeetings();
});

export const selectWeeklyMeetings = (state: RootState) => {
  return state.weeklyMeetings.WeeklyMeetings;
};

export const selectLoadingWeeklyMeetings = (state: RootState) => {
  return state.weeklyMeetings.LoadingWeeklyMeetings;
};

export default WeeklyMeetingsSlice.reducer;
